import { useQuery } from '@tanstack/react-query'
import { appLabelClass, appLabelTitle, ticketAppLabelQuery } from './appLabel'

/**
 * Capul tichetului (fisa si randul desfasurat): "Charisma ERP (Critical)"
 * cand un aparat / CI al tichetului e componenta unei aplicatii de business.
 *
 * Fara aplicatie, fara drept, inainte de migrare sau cu capatul cazut, nu se
 * deseneaza nimic: tichetul arata ca pana acum.
 */
export function TicketAppLabel({ id }: { id: number }) {
  const { data } = useQuery({ ...ticketAppLabelQuery(id), retry: false })
  const label = data?.label
  if (!label) return null

  return (
    <div className="tk-app-head" data-testid="ticket-app-label">
      <span className={`label ${appLabelClass(label.criticality)} tk-app-label`} title={appLabelTitle(label)}>
        <i className="fas fa-cubes" aria-hidden="true"></i> {label.text}
        {label.more > 0 && <span className="tk-app-label-more">+{label.more}</span>}
      </span>
    </div>
  )
}
